import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './export-shipments.actions';

const initialState = {
  jobIdToJobMap: {},
};

const actionHandlerMap = {
  [Actions.EXPORT_SHIPMENTS_SUCCESS]: (state, { jobId, initiatedByUserId }) => {
    const { jobIdToJobMap } = state;
    return {
      ...state,
      jobIdToJobMap: {
        ...jobIdToJobMap,
        [jobId]: {
          id: jobId,
          initiatedByUserId,
        },
      },
    };
  },
  [Actions.EXPORT_SHIPMENTS_COMPLETE]: (state, { messageGuid, data }) => {
    const { jobIdToJobMap } = state;
    const job = jobIdToJobMap[messageGuid];
    return {
      ...state,
      jobIdToJobMap: {
        ...jobIdToJobMap,
        [messageGuid]: {
          ...job,
          ...data,
        },
      },
    };
  },
  [Actions.EXPORT_SHIPMENTS_CLEANUP]: (state, { jobId }) => {
    const { jobIdToJobMap } = state;
    delete jobIdToJobMap[jobId];
    return {
      ...state,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './export-shipments.reducer.metadata';
